/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var NumberCircle01Icon20Regular = forwardRef('NumberCircle01Icon20Regular', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 20 }, props),
        React.createElement("path", { d: "M11.108 12.836V6.011H9.922L7.458 7.875l.746 1.04 1.379-1.017v4.938H7.73V14h5.152v-1.164h-1.774Z" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M10 2.001A7.999 7.999 0 1 0 10 18 7.999 7.999 0 0 0 10 2Zm-6.499 8A6.499 6.499 0 1 1 16.5 10 6.499 6.499 0 0 1 3.5 10Z" })));
});
